import { ReactNode } from "react";
import { Link } from "@/router";

type ButtonLinkProps = {
  href: string;
  children: ReactNode;
  variant?: "primary" | "secondary" | "ghost";
  disabled?: boolean;
};

export function ButtonLink({ href, children, variant = "primary", disabled = false }: ButtonLinkProps) {
  if (disabled) {
    return (
      <span className={`button button-${variant} is-disabled`} aria-disabled="true">
        {children}
      </span>
    );
  }

  return (
    <Link href={href} className={`button button-${variant}`}>
      {children}
    </Link>
  );
}
